import { rawFavorites } from '@components';
import { usePageTitle } from '@contexts/PageTitleContext';
import { CustomIcon, Icon, liseraiEcs, showToast, SkeletonComponent, Typography } from '@design-system';
import { getFirstname } from '@features/auth/auth.slice';
import { getCompanyChoice } from '@features/company/company.slice';
import { useFavorites } from '@hooks';
import React, { useCallback } from 'react';
import { FaBookmark, FaRegBookmark } from 'react-icons/fa';
import { LiaArrowLeftSolid } from 'react-icons/lia';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import './PageTitle.scss';
import { pageTitles } from './pageTitles';

export const PageTitle: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const firstname = useSelector(getFirstname);
    const companyChoice = useSelector(getCompanyChoice);
    const { customPageTitle } = usePageTitle();

    const item = pageTitles[location.pathname] ?? undefined;
    const isHomePage = location.pathname === '/home';

    const { favorites, handleAddFavorite, handleDeleteFavorite } = useFavorites();

    const isFavorite = useCallback(() => {
        const rawFavorite = Object.entries(rawFavorites).find(([, value]) => value.link === location.pathname);

        return favorites.find((favorite) => favorite.reference === rawFavorite?.[0]);
    }, [favorites, location.pathname]);

    if (item?.hideHeader) {
        return null;
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    const favoriteOnClick = () => {
        const rawFavorite = Object.entries(rawFavorites).find(([, value]) => value.link === location.pathname);

        console.log('location.pathname', location.pathname);

        if (!rawFavorite) {
            showToast({
                type: 'error',
                message: 'Page non trouvée'
            });
            return;
        }

        if (favorites.find((favorite) => favorite.reference === rawFavorite[0])) {
            const favoriteId = favorites.find((favorite) => favorite.reference === rawFavorite[0])?.id;
            if (favoriteId) {
                handleDeleteFavorite(favoriteId);
            }
            return;
        }

        handleAddFavorite(rawFavorite[0]);
    };

    if (customPageTitle) {
        return (
            <div className="page-title">
                <Icon className="arrow-left" color="grey" icon={<LiaArrowLeftSolid />} size={35} onClick={handleGoBack} />
                {customPageTitle}
            </div>
        );
    }

    if (!item) {
        return (
            <div className="page-title">
                <Icon className="arrow-left" color="grey" icon={<LiaArrowLeftSolid />} size={35} onClick={handleGoBack} />

                <SkeletonComponent
                    count={1}
                    style={{
                        width: 'calc(100vw - 48px)',
                        height: '36px',
                        borderRadius: '8px'
                    }}
                />
            </div>
        );
    }

    const { title, titleElement, hasFavorite } = item;

    const isOccitanie = companyChoice === 'ecs-occitanie';

    if (isHomePage) {
        return (
            <div className="page-title column">
                <CustomIcon
                    src={isOccitanie ? liseraiEcs : liseraiEcs}
                    alt={isOccitanie ? 'Liserai ECS Occitanie' : 'Liserai ECS'}
                    className="liserai"
                />
                {firstname && (
                    <Typography intrinsic="h1" color="green">
                        Bonjour {firstname},
                    </Typography>
                )}
                <Typography intrinsic="h1" variant="sub">
                    Bienvenue sur votre espace {isOccitanie ? 'Occitanie' : ''}
                </Typography>
            </div>
        );
    }

    if (titleElement) {
        return (
            <div className="page-title">
                <Icon
                    className="arrow-left"
                    color="grey"
                    icon={<LiaArrowLeftSolid />}
                    size={35}
                    onClick={() => {
                        if (item.customNavigate) {
                            navigate(item.customNavigate);
                        } else {
                            handleGoBack();
                        }
                    }}
                />
                {titleElement}
                {hasFavorite && !isFavorite() && <FaRegBookmark className="favorite-icon" onClick={favoriteOnClick} />}
                {hasFavorite && isFavorite() && <FaBookmark className="favorite-icon" onClick={favoriteOnClick} />}
            </div>
        );
    }

    return (
        <div className="page-title">
            <Icon className="arrow-left" color="grey" icon={<LiaArrowLeftSolid />} size={35} onClick={handleGoBack} />
            <Typography intrinsic="h1">{title}</Typography>
            {hasFavorite && !isFavorite() && <FaRegBookmark className="favorite-icon" onClick={favoriteOnClick} />}
            {hasFavorite && isFavorite() && <FaBookmark className="favorite-icon" onClick={favoriteOnClick} />}
        </div>
    );
};
